'use client';

import MuxPlayer from '@mux/mux-player-react';
import { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system/styleFunctionSx';
import { mergeSx } from '@jucy-ui/appearance';
import { prefixCmsUrl } from '@/lib/prefixCmsUrl';
import texture from './video-banner-texture.png';

export type VideoBannerProps = {
    useTexture?: boolean;
    sx?: SxProps<Theme>;
    size: keyof Theme['settings']['bannerHeights'];
    poster?: string;
    playbackId: string;
    className?: string;
};

export const VideoBanner = ({ useTexture, sx, size, poster: inPoster, playbackId, className }: VideoBannerProps) => {
    const poster = inPoster ? prefixCmsUrl(inPoster) : `https://image.mux.com/${playbackId}/thumbnail.jpg?time=0`;
    return (
        <Box
            className={className}
            sx={mergeSx(
                {
                    height: (theme) => theme.settings.bannerHeights[size],
                    ...(poster
                        ? {
                              backgroundImage: `url(${poster})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center center',
                          }
                        : undefined),
                    ...(useTexture
                        ? {
                              position: 'relative',
                              '&:after': {
                                  background: `url(${texture.src})`,
                                  content: '" "',
                                  display: 'block',
                                  inset: '0',
                                  position: 'absolute',
                              },
                          }
                        : undefined),
                },
                sx
            )}
        >
            <Box
                streamType="on-demand"
                component={MuxPlayer}
                metadata={{
                    video_title: 'Home page banner',
                }}
                placeholder={poster}
                accentColor="#ea580c"
                playbackId={playbackId}
                sx={{
                    height: '100%',
                    objectFit: 'cover',
                    width: '100%',
                    '--controls': 'none',
                    '---loading-indicator': 'none',
                    '--media-object-fit': 'cover',
                    '--media-object-position': 'center',
                    '--seek-backward-button': 'none',
                    '--seek-forward-button': 'none',
                    '--center-controls': 'none',
                    '--top-captions-button': 'none',
                }}
                nohotkeys={true}
                autoPlay="muted"
                loop={true}
                preload="auto"
                muted={true}
                poster={poster}
            />
        </Box>
    );
};
